let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6dERU"), load("7gF8f"), load("gd4qs"), load("YEGhv"), load("dBb6q"), load("eJgH8")]).then(() => parcelRequire('4Wx0w'));